import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { GET_SAVED_QUERY_ROWS_COUNT } from '@/features/query-builder/savedQueriesApiSlice';
import { RollbarApi } from '@/integrations/Rollbar';

// TODO: remove this middleware and handle errors inside hooks.
export const rtkQueryErrorLogger: Middleware =
  (_api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const status =
        typeof action.payload?.status === 'number'
          ? action.payload?.status
          : action.payload?.originalStatus;

      switch (status) {
        case 401:
          errorNotification(
            'Problem loading data',
            "You've been logged out. Refresh the page and log back in",
          );
          break;
        case 400:
          if (action.meta.arg.endpointName === GET_SAVED_QUERY_ROWS_COUNT) {
            //
          } else if (
            action.type === 'bucketFeedsApi/executeMutation/rejected'
          ) {
            const errorMessage = action.payload.data._msg;
            NotificationManager.error(
              errorMessage,
              'Problem testing S3 bucket',
              10 * 1000,
            );
          } else if (action.payload?.data?._reason === 'EXECUTION_CANCELLED') {
            //
          } else if (!action.payload?.data?._layerId) {
            errorNotification(
              'Problem loading data',
              action.payload.error,
              action,
            );
          }
          break;
        case 422:
          errorNotification(
            'Problem loading data',
            action.payload.data,
            action,
          );
          break;
      }
    }

    return next(action);
  };

const errorNotification = (title: string, message: string, action?: any) => {
  if (action) {
    RollbarApi.then((rollbar) =>
      // @ts-expect-error: TODO: provide better typing.
      rollbar.error('[CAUGHT] fetch error', JSON.stringify(action)),
    );
  }

  NotificationManager.error(title, message, 10 * 1000);
};
